import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import rootReducer from './redux';
import rootSaga from './redux/rootSaga';

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();
const history = createBrowserHistory();
const enhancer = composeEnhancers(applyMiddleware(routerMiddleware(history), sagaMiddleware));
const store = createStore(rootReducer(history), enhancer);

// expose store when run in Cypress
if (window.Cypress) {
  window.store = store;
}

sagaMiddleware.run(rootSaga);

export { store, history };
